/* eslint-disable import/no-unresolved */
import { FinancialStatementPeriod } from 'common/types/financials';
import { reverseParser as baseReverseParser, updateNeedsActualizationState } from 'pages/Financials/utilities';
import { IncomeStatementCell } from './types';
import rowConfig from '../data/rowConfig';

const reverseParser = ({
  cells,
  columns,
  fieldAttributes,
  allowEmptyValues = true,
}: {
  cells: Record<string, IncomeStatementCell[]>;
  columns: FinancialStatementPeriod[];
  fieldAttributes: object;
  allowEmptyValues?: boolean;
}) => {
  const localConfig = rowConfig(!!columns);

  const baseReverseParsedColumns = baseReverseParser({
    cells,
    columns,
    allowEmptyValues,
    rowConfig: localConfig,
    fieldAttributes,
  });

  return updateNeedsActualizationState(baseReverseParsedColumns, cells);
};
export default reverseParser;
